import { Badge } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import type { TDonationStatus } from '../model/donor-detail.types'

const styles: Record<
  TDonationStatus,
  { bg: string; color: string; labelKey: string }
> = {
  SUCCESSFUL: {
    bg: 'badge.green.20',
    color: 'badge.green.100',
    labelKey: 'success_badge',
  },
  UNSUCCESSFUL: {
    bg: 'badge.red.20',
    color: 'badge.red.100',
    labelKey: 'failed_badge',
  },
}

interface Props {
  result: TDonationStatus
  w?: string
  textAlign?: 'left' | 'center' | 'right'
}

export function ResultBadge({ w, result, textAlign }: Props) {
  const { t } = useTranslation()
  const s = styles[result]
  return (
    <Badge
      px={2}
      w={w || 'fit-content'}
      py={0.5}
      borderRadius="md"
      fontSize="xs"
      bg={s.bg}
      color={s.color}
      textAlign={textAlign || 'left'}
    >
      {t(`donor_detail.history.${s.labelKey}`)}
    </Badge>
  )
}
